/* Description videos: assign sources only near the viewport. No analytics. */
(() => {
  'use strict';
  const seen = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function activate(video) {
    if (video.dataset.yaabLoaded === 'true') return;
    video.dataset.yaabLoaded = 'true';
    if (video.dataset.src) {
      video.src = video.dataset.src;
      delete video.dataset.src;
    }
    video.querySelectorAll('source[data-src]').forEach(source => {
      source.src = source.dataset.src;
      delete source.dataset.src;
    });
    video.load();
    if (video.dataset.autoplay === 'true' && !reducedMotion.matches) {
      video.muted = true;
      const playback = video.play();
      if (playback && typeof playback.catch === 'function') playback.catch(() => {});
    }
  }
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        activate(entry.target);
      });
    }, { rootMargin: '250px 0px' }) : null;
  function init(root = document) {
    root.querySelectorAll('video[data-yaab-video]').forEach(video => {
      if (seen.has(video)) return;
      seen.add(video);
      video.controls = true;
      // A user can always start playback, including with reduced motion enabled.
      video.addEventListener('pointerdown', () => activate(video), { once: true });
      video.addEventListener('keydown', () => activate(video), { once: true });
      if (observer) observer.observe(video);
      else activate(video);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
